import { useGetInputTypesQuery } from "@app/hooks/useDropdownOptionsHooks";
import { useContextAwareGetInputEntries } from "@app/hooks/useInputsHooks";
import { useAppSelector } from "@app/hooks";
import { useMemo, useEffect, SetStateAction } from "react";
import { getIn, useFormikContext } from "formik";
import { ModuleFull } from "./inputsTypes";
import { selectCurrentProject } from "@app/features/project/projectSlice";
import { isEqual } from 'lodash';
import { mergeLocalAndServerChanges } from "./utils";

const INPUT_TYPE_INPUT_NAME = "input_type"

export const useInputValues = (setInitValues: (value: SetStateAction<ModuleFull>) => void) => {
  const { data: inputTypes } = useGetInputTypesQuery();
  const { activeActivityId } = useAppSelector(selectCurrentProject);
  const { values } = useFormikContext<ModuleFull>()

  const { data: entriesData } = useContextAwareGetInputEntries({ activityId: activeActivityId ?? 0 });
  const list = useMemo(() => {
    const entries = values.entries.map(entry => ({ ...entry, input_type_unit: entry.input_type_unit ?? "" }))
    for (const [index, item] of entries.entries()) {
      const inputType = getIn(item, INPUT_TYPE_INPUT_NAME)

      const unit = inputTypes?.find(o => o.id === inputType)?.unit ?? "";
      const next = unit ? `[${unit}]` : null;

      entries[index].input_type_unit = next ?? ""
    }

    const isEntriesUpdated = !isEqual(entries, entriesData)
    return isEntriesUpdated ? mergeLocalAndServerChanges({
      currentChangesList: entries,
      incomingList: entriesData ?? []
    }) : entries
  }, [entriesData, values.entries])

  useEffect(() => {
    if (list && !isEqual(list, values.entries)) {
      setInitValues((cur: ModuleFull) => ({ ...cur, entries: list }))
    }
  }, [list, inputTypes, setInitValues, values.entries])

  return { values }
}